import { Spinner } from "components/Spinner";
import PageWrapper from "components/PageWrapper";
import Icon from "ds/components/Icon";

import styles from "./styles.module.css";

type PageLoadingProps = {
  message?: string;
};

const PageLoading = ({ message }: PageLoadingProps) => (
  <PageWrapper className={styles.wrapper}>
    <div className={styles.loading}>
      <Icon src={Spinner} size="x-large" />
      {message}
    </div>
  </PageWrapper>
);

export default PageLoading;
